<template>
  <section class="notifications">
    <slot name="before"></slot>
    <section v-if="showNotification">
      <NotificationContent
        class="content"
        @read-notification="clickNotification"
        :notifications="notifications"
      >
        <template #after>
          <li
            v-if="!isLastPage"
            @click="handleViewMore"
            class="noti-item link-color font-bold cursor-pointer text-center"
          >
            <span v-if="!isLoading">{{ $i18nPresenter.t('See more notifications') }}</span>
            <aha-spinner v-if="isLoading" />
          </li>
        </template>
      </NotificationContent>
    </section>
    <slot name="after"></slot>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import NotificationContent from '@/components-v2/common/notification/NotificationContent.vue'

export default {
  name: 'NotificationsSectionV2',
  components: {
    NotificationContent,
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    showNotification: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('notificationModule', ['isLastPage', 'isLoading']),
  },
  methods: {
    ...mapActions('notificationModule', [
      'getNotificationsAction',
    ]),
    clickNotification(notification) {
      this.$emit('read-notification', notification)
    },
    handleViewMore() {
      if (this.isLoading) return
      this.getNotificationsAction()
      this.$emit('view-more-click')
    },
  },
}
</script>
<style lang="scss" scoped>
    .notifications {
        @apply rounded-lg shadow-card;
        background-color: white;

        & .content {
          --border-color: #D3D7E1;
          &::v-deep {
            & h3.w-full {
              display: none;
            }

            & ul {
              & > li {
                border-bottom: 1px solid var(--border-color);

                & .noti-content {
                  & > h4,p {
                    max-width: 720px;
                  }
                  & img {
                    width: 100%;
                    max-width: 100%;
                    @media (min-width: 768px) {
                      max-width: 320px;
                      max-height: 426px;
                    }
                  }
                }

                &:last-child {
                  border-bottom: none;
                }
              }
            }
          }
        }
    }
</style>
